import { render, staticRenderFns } from "./truncated-text.vue?vue&type=template&id=08783056&scoped=true&"
import script from "./truncated-text.vue?vue&type=script&lang=js&"
export * from "./truncated-text.vue?vue&type=script&lang=js&"
import style0 from "./truncated-text.vue?vue&type=style&index=0&id=08783056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08783056",
  null
  
)

export default component.exports